module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result01-ce20390e3b05c9ec3725847298b1f27f.png";